
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface VideoUrlInputProps {
  platform: 'youtube' | 'vimeo';
  url: string;
  setUrl: (url: string) => void;
}

const VideoUrlInput = ({ platform, url, setUrl }: VideoUrlInputProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="video-url">{platform === 'youtube' ? 'YouTube' : 'Vimeo'} URL</Label>
      <Input
        id="video-url"
        type="url"
        placeholder={platform === 'youtube' ? 'https://www.youtube.com/watch?v=...' : 'https://vimeo.com/...'}
        value={url}
        onChange={(e) => setUrl(e.target.value)}
      />
    </div>
  );
};

export default VideoUrlInput;
